import React, { createContext, useContext } from "react";

const SeoContext = createContext({
  title: "Default Title",
  description: "Default description for the website.",
  keywords: "default, keywords",
  author: "Default Author",
  canonical: "",
  // themeColor: "#2d378b",
  ogTitle: "",
  ogDescription: "",
  ogUrl: "",
  ogImage: "",
  twitterCard: "summary_large_image",
  twitterTitle: "",
  twitterDescription: ""
});

// Provider für globale SEO Defaults
export const SeoProvider = ({ children, seoDefaults }) => {
  return (
    <SeoContext.Provider value={{ ...seoDefaults }}>
      {children}
    </SeoContext.Provider>
  );
};

export const useSeo = () => useContext(SeoContext);
